var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $gvars = Opal.gvars, $truthy = Opal.truthy;

  Opal.add_stubs(['$setPrefixes', '$gsub', '$nechronica_check', '$==', '$>=', '$<=', '$>', '$+', '$debug', '$=~', '$to_i', '$parren_killer', '$roll', '$<', '$collect', '$split', '$times', '$length', '$[]', '$[]=', '$-', '$join', '$check_suc', '$getHitLocation', '$!=']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Nechronica_Korean');

    var $nesting = [self].concat($parent_nesting), $Nechronica_Korean_initialize$1, $Nechronica_Korean_gameName$2, $Nechronica_Korean_gameType$3, $Nechronica_Korean_getHelpMessage$4, $Nechronica_Korean_changeText$5, $Nechronica_Korean_dice_command_xRn$10, $Nechronica_Korean_check_nD10$11, $Nechronica_Korean_nechronica_check$12, $Nechronica_Korean_getHitLocation$15;

    self.$$prototype.nick_t = nil;
    
    self.$setPrefixes(["(\\d+NC|\\d+NA)"]);
    
    Opal.def(self, '$initialize', $Nechronica_Korean_initialize$1 = function $$initialize() {
      var $iter = $Nechronica_Korean_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $Nechronica_Korean_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $Nechronica_Korean_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      self.sortType = 3;
      return (self.defaultSuccessTarget = "6");
    }, $Nechronica_Korean_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $Nechronica_Korean_gameName$2 = function $$gameName() {
      var self = this;

      return "네크로니카"
    }, $Nechronica_Korean_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $Nechronica_Korean_gameType$3 = function $$gameType() {
      var self = this;

      return "Nechronica:Korean"
    }, $Nechronica_Korean_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $Nechronica_Korean_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "・판정　(nNC+m)\n" + "　주사위 수n、수정치m으로 판정굴림을 행합니다.\n" + "　주사위 수가 2개 이상일 때에 파츠파손 수도 표시합니다.\n" + "・공격판정　(nNA+m)\n" + "　주사위 수n、수정치m으로 공격판정굴림을 행합니다.\n" + "　명중부위와 주사위 수가 2개 이상일 때에 파츠파손 수도 표시합니다.\n"
    }, $Nechronica_Korean_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$changeText', $Nechronica_Korean_changeText$5 = function $$changeText(string) {
      var $$6, $$7, $$8, $$9, self = this;

      
      string = $send(string, 'gsub', [/(\d+)NC(10)?([\+\-][\+\-\d]+)/i], ($$6 = function(){var self = $$6.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + "R10" + (__last__match__3) + "[0]";}, $$6.$$s = self, $$6.$$arity = 0, $$6));
      string = $send(string, 'gsub', [/(\d+)NC(10)?/i], ($$7 = function(){var self = $$7.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + "R10[0]";}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      string = $send(string, 'gsub', [/(\d+)NA(10)?([\+\-][\+\-\d]+)/i], ($$8 = function(){var self = $$8.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + "R10" + (__last__match__3) + "[1]";}, $$8.$$s = self, $$8.$$arity = 0, $$8));
      string = $send(string, 'gsub', [/(\d+)NA(10)?/i], ($$9 = function(){var self = $$9.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + "R10[1]";}, $$9.$$s = self, $$9.$$arity = 0, $$9));
      return string;
    }, $Nechronica_Korean_changeText$5.$$arity = 1);
    
    Opal.def(self, '$dice_command_xRn', $Nechronica_Korean_dice_command_xRn$10 = function $$dice_command_xRn(string, nick_e) {
      var self = this;

      
      self.nick_e = nick_e;
      return self.$nechronica_check(string);
    }, $Nechronica_Korean_dice_command_xRn$10.$$arity = 2);
    
    Opal.def(self, '$check_nD10', $Nechronica_Korean_check_nD10$11 = function $$check_nD10(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this, result = nil;

      
      if ($truthy(signOfInequality['$=='](">="))) {
      } else {
        return ""
      };
      if ($truthy($rb_ge(total_n, 11))) {
        return " ＞ 대성공"};
      if ($truthy($rb_ge(total_n, diff))) {
        return " ＞ 성공"};
      if ($truthy($rb_le(n1, 0))) {
        return " ＞ 실패"};
      result = " ＞ 대실패";
      if ($truthy($rb_gt(dice_cnt, 1))) {
        result = $rb_plus(result, " ＞ 사용파츠 전부 손실")};
      return result;
    }, $Nechronica_Korean_check_nD10$11.$$arity = 8);
    
    Opal.def(self, '$nechronica_check', $Nechronica_Korean_nechronica_check$12 = function $$nechronica_check(string) {
      var $a, $b, $$13, $$14, self = this, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, signOfInequality = nil, dice_n = nil, modText = nil, mod = nil, battleMode = nil, isBattleMode = nil, diff = nil, total_n = nil, _ = nil, dice_str = nil, n1 = nil, cnt_max = nil, n_max = nil, dice = nil, diceMax = nil, hit_loc = nil;

      
      output = "1";
      self.$debug("nechronica_check string", string);
      if ($truthy(/(^|\s)S?((\d+)[rR]10([\+\-\d]+)?(\[(\d+)\])?)(\s|$)/i['$=~'](string))) {
      } else {
        
        self.$debug("nechronica_check unmuched");
        return output;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      signOfInequality = ">=";
      dice_n = 1;
      if ($truthy(__last__match__3)) {
        dice_n = __last__match__3.$to_i()};
      modText = __last__match__4;
      mod = self.$parren_killer("" + "(0" + (modText) + ")").$to_i();
      battleMode = __last__match__6.$to_i();
      isBattleMode = battleMode['$=='](1);
      self.$debug("nechronica_check string", string);
      self.$debug("isBattleMode", isBattleMode);
      diff = 6;
      total_n = 0;
      $b = self.$roll(dice_n, 10, 1), $a = Opal.to_ary($b), (_ = ($a[0] == null ? nil : $a[0])), (dice_str = ($a[1] == null ? nil : $a[1])), (n1 = ($a[2] == null ? nil : $a[2])), (cnt_max = ($a[3] == null ? nil : $a[3])), (n_max = ($a[4] == null ? nil : $a[4])), $b;
      total_n = $rb_plus(n_max, mod);
      output = "" + (self.nick_t) + ": (" + (string) + ") ＞ [" + (dice_str) + "]";
      if ($truthy($rb_lt(mod, 0))) {
        output = $rb_plus(output, "" + (mod))
      } else if ($truthy($rb_gt(mod, 0))) {
        output = $rb_plus(output, "" + "+" + (mod))};
      n1 = 0;
      cnt_max = 0;
      dice = $send(dice_str.$split(/,/), 'collect', [], ($$13 = function(i){var self = $$13.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$to_i();}, $$13.$$s = self, $$13.$$arity = 1, $$13));
      $send(dice.$length(), 'times', [], ($$14 = function(i){var self = $$14.$$s || this, $writer = nil;

      
        
        if (i == null) {
          i = nil;
        };
        
        $writer = [i, $rb_plus(dice['$[]'](i), mod)];
        $send(dice, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        if ($truthy($rb_le(dice['$[]'](i), 1))) {
          n1 = $rb_plus(n1, 1)};
        if ($truthy($rb_ge(dice['$[]'](i), 10))) {
          return (cnt_max = $rb_plus(cnt_max, 1))
        } else {
          return nil
        };}, $$14.$$s = self, $$14.$$arity = 1, $$14));
      dice_str = dice.$join(",");
      output = $rb_plus(output, "" + "  ＞ " + (total_n) + "[" + (dice_str) + "]");
      diceMax = 10;
      output = $rb_plus(output, self.$check_suc(total_n, n_max, signOfInequality, diff, dice_n, diceMax, n1, n_max));
      self.$debug("dice_n, n1, total_n diff", dice_n, n1, total_n, diff);
      if ($truthy(isBattleMode)) {
        
        hit_loc = self.$getHitLocation(total_n);
        if ($truthy(hit_loc['$!=']("1"))) {
          output = $rb_plus(output, "" + " ＞ " + (hit_loc))};};
      return output;
    }, $Nechronica_Korean_nechronica_check$12.$$arity = 1);
    return (Opal.def(self, '$getHitLocation', $Nechronica_Korean_getHitLocation$15 = function $$getHitLocation(dice) {
      var self = this, output = nil, table = nil, index = nil, addDamage = nil;

      
      output = "1";
      self.$debug("getHitLocation dice", dice);
      if ($truthy($rb_le(dice, 5))) {
        return output};
      output = "";
      table = ["방어측 임의", "다리（없으면 공격측 임의）", "몸통（없으면 공격측 임의）", "팔（없으면 공격측 임의）", "머리（없으면 공격측 임의）", "공격측 임의"];
      index = $rb_minus(dice, 6);
      addDamage = "";
      if ($truthy($rb_gt(dice, 10))) {
        
        index = 5;
        addDamage = "" + "(추가 데미지" + ($rb_minus(dice, 10)) + ")";};
      output = $rb_plus(table['$[]'](index), addDamage);
      return output;
    }, $Nechronica_Korean_getHitLocation$15.$$arity = 1), nil) && 'getHitLocation';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
